/* Chaski Cacao product page - consolidated behaviour
   Rebuilt from PageFly sections pf-9b39cea0 / pf-72cccb17.
   The two near-identical buy-box scripts are merged into one
   parameterised initialiser. */
(function () {
  'use strict';

  /* ---------- cart drawer ----------
     The PageFly original added to cart and then did nothing at all - no
     drawer, no redirect, no confirmation beyond a brief change of button
     text. (It even shipped a commented-out `window.location.href =
     '/cart'`.) A customer pressing BUY NOW saw no response and had no
     reason to believe it had worked.

     UpCart exposes upcartRefreshCart() and upcartOpenCart() as globals.
     Calling them after a successful add gives the customer immediate
     feedback and a route to checkout. Both are probed defensively so the
     page still works if UpCart is ever removed. */
  function openCartDrawer() {
    try {
      if (typeof window.upcartRefreshCart === 'function') {
        window.upcartRefreshCart();
      }
      if (typeof window.upcartOpenCart === 'function') {
        window.upcartOpenCart();
        return true;
      }
    } catch (e) {
      console.warn('Chaski: cart drawer unavailable', e);
    }
    /* No drawer app present - fall back to a plain cart-updated event so
       the theme (or any other cart UI) can react. */
    document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
    return false;
  }

  /* ---------- smooth scroll to the Loox review block ---------- */

  window.chaskiScrollToReviews = function (e) {
    if (e) { e.preventDefault(); }
    var target = document.getElementById('chaski-reviews');
    if (target) {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  window.chaskiScrollTop = function (e) {
    if (e) { e.preventDefault(); }
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  /* ---------- accordions ---------- */

  window.toggleChaskiBoost = function (row) {
    row.classList.toggle('open');
  };

  function faqToggle(button, itemSel, cardSel) {
    var item = button.closest(itemSel);
    var card = item.closest(cardSel);
    var isOpen = item.classList.contains('open');
    card.querySelectorAll(itemSel).forEach(function (el) {
      el.classList.remove('open');
    });
    if (!isOpen) { item.classList.add('open'); }
  }

  window.toggleChaskiFaq = function (button) {
    faqToggle(button, '.chaski-faq-item', '.chaski-faq-card');
  };

  window.toggleChaskiFqd = function (button) {
    faqToggle(button, '.chaski-fq-item', '.chaski-fq-card');
  };

  /* ---------- gallery ---------- */

  function initGallery(root) {
    var main = root.querySelector('[data-chaski-main]');
    var thumbs = root.querySelectorAll('[data-chaski-thumb]');
    if (!main || !thumbs.length) { return; }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        thumbs.forEach(function (t) { t.classList.remove('active'); });
        thumb.classList.add('active');
        var img = main.querySelector('img');
        if (!img) { return; }
        img.src = thumb.getAttribute('data-full');
        img.srcset = thumb.getAttribute('data-srcset') || '';
        img.alt = thumb.getAttribute('data-alt') || '';
      });
    });
  }

  /* ---------- buy box ---------- */

  function initBuyBox(cfg) {
    var root = document.querySelector(cfg.root);
    if (!root) { return; }

    var cards = root.querySelectorAll(cfg.card);
    var button = root.querySelector(cfg.button);
    var text = root.querySelector(cfg.text);
    var oldPriceEl = root.querySelector(cfg.oldPrice);
    var newPriceEl = root.querySelector(cfg.newPrice);
    if (!button) { return; }

    cards.forEach(function (card) {
      card.addEventListener('click', function () {
        cards.forEach(function (item) { item.classList.remove('active'); });
        card.classList.add('active');

        var oldPrice = card.getAttribute('data-old-price');
        var buttonPrice = card.getAttribute('data-button-price');

        if (newPriceEl) { newPriceEl.textContent = buttonPrice; }

        if (oldPriceEl) {
          if (oldPrice) {
            oldPriceEl.textContent = oldPrice;
            oldPriceEl.classList.remove('is-hidden');
          } else {
            oldPriceEl.textContent = '';
            oldPriceEl.classList.add('is-hidden');
          }
        }
      });
    });

    button.addEventListener('click', function (event) {
      event.preventDefault();

      var activeCard = root.querySelector(cfg.card + '.active');
      if (!activeCard) { return; }

      var variantId = Number(activeCard.getAttribute('data-variant-id'));
      var quantity = Number(activeCard.getAttribute('data-quantity')) || 1;
      var sellingPlanId = activeCard.getAttribute('data-selling-plan-id');

      var originalText = text ? text.textContent : '';
      button.classList.add('is-loading');
      if (text) { text.textContent = cfg.loadingLabel; }

      var item = { id: variantId, quantity: quantity };
      if (sellingPlanId) { item.selling_plan = Number(sellingPlanId); }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ items: [item] })
      })
        .then(function (response) {
          if (!response.ok) {
            return response.json().then(function (data) {
              throw new Error(data.description || 'Unable to add item to cart.');
            });
          }
          return response.json();
        })
        .then(function () {
          if (text) { text.textContent = originalText; }
          button.classList.remove('is-loading');
          openCartDrawer();
        })
        .catch(function (error) {
          console.error('Chaski purchase error:', error);
          if (text) { text.textContent = cfg.errorLabel; }
          setTimeout(function () {
            if (text) { text.textContent = originalText; }
            button.classList.remove('is-loading');
          }, 2000);
        });
    });
  }

  /* ---------- second buy box (landing body) ---------- */

  window.selectChaskiOption = function (selected) {
    var parent = selected.parentElement;
    parent.querySelectorAll('.chaski-option').forEach(function (el) {
      el.classList.remove('active');
    });
    selected.classList.add('active');
  };

  window.updateChaskiSupply = function (select) {
    var card = select.closest('.chaski-purchase-card') || document;
    var sub = card.querySelector('.chaski-option[data-option="subscription"]');
    if (!sub) { return; }

    var is90 = select.value === '90';
    var title = sub.querySelector('.chaski-option-title');
    var badge = sub.querySelector('.chaski-option-badge');
    var subtitle = sub.querySelector('.chaski-option-subtitle');
    var current = sub.querySelector('.chaski-option-price');
    var oldPrice = sub.querySelector('.chaski-option-old-price');

    var data = sub.dataset;

    if (is90) {
      if (title) { title.innerHTML = '90 day<br>supply'; }
      if (badge) { badge.innerHTML = '<span>Best value</span>'; }
      if (subtitle) {
        subtitle.innerHTML =
          '<div><span class="chaski-sub-check">&#10003;</span> 3x tubes delivered every 3 months</div>' +
          '<div><span class="chaski-sub-check">&#10003;</span> Swap, skip or cancel any time</div>';
      }
      if (current) { current.textContent = data.price90; }
      if (oldPrice) { oldPrice.textContent = data.compare90; }
      sub.setAttribute('data-variant-id', data.variant90);
      sub.setAttribute('data-selling-plan-id', data.plan90);
    } else {
      if (title) { title.innerHTML = 'Subscribe<br>&amp; Save'; }
      if (badge) { badge.innerHTML = '<span>SAVE</span> <strong>' + data.saving + '</strong>'; }
      if (subtitle) {
        subtitle.innerHTML =
          '<div><span class="chaski-sub-check">&#10003;</span> 1 tube delivered monthly</div>' +
          '<div><span class="chaski-sub-check">&#10003;</span> Swap, skip or cancel any time</div>';
      }
      if (current) { current.textContent = data.price30; }
      if (oldPrice) { oldPrice.textContent = data.compare30; }
      sub.setAttribute('data-variant-id', data.variant30);
      sub.setAttribute('data-selling-plan-id', data.plan30);
    }
  };

  window.addChaskiToCart = function (button) {
    var card = button.closest('.chaski-purchase-card') || document;
    var active = card.querySelector('.chaski-option.active');
    if (!active) { return; }

    var variantId = Number(active.getAttribute('data-variant-id'));
    var sellingPlanId = active.getAttribute('data-selling-plan-id');
    var original = button.textContent;

    button.disabled = true;
    button.textContent = 'Adding...';

    var item = { id: variantId, quantity: 1 };
    if (sellingPlanId) { item.selling_plan = Number(sellingPlanId); }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ items: [item] })
    })
      .then(function (response) {
        if (!response.ok) { throw new Error('add failed'); }
        return response.json();
      })
      .then(function () {
        button.textContent = 'Added ✓';
        openCartDrawer();
        setTimeout(function () {
          button.textContent = original;
          button.disabled = false;
        }, 1500);
      })
      .catch(function (error) {
        console.error('Chaski add to cart error:', error);
        button.textContent = 'Try again';
        setTimeout(function () {
          button.textContent = original;
          button.disabled = false;
        }, 2000);
      });
  };

  /* ---------- boot ---------- */

  function boot() {
    document.querySelectorAll('[data-chaski-gallery]').forEach(initGallery);

    initBuyBox({
      root: '.chaski-mobile-purchase-options',
      card: '.chaski-mobile-purchase-card',
      button: '.chaski-mobile-buy-button',
      text: '.chaski-mobile-buy-text',
      oldPrice: '.chaski-mobile-button-old-price',
      newPrice: '.chaski-mobile-button-new-price',
      loadingLabel: 'ADDING...',
      errorLabel: 'TRY AGAIN'
    });

    initBuyBox({
      root: '.purchase-options',
      card: '.purchase-card',
      button: '.chaski-buy-button',
      text: '.chaski-buy-text',
      oldPrice: '.chaski-button-old-price',
      newPrice: '.chaski-button-new-price',
      loadingLabel: 'ADDING...',
      errorLabel: 'TRY AGAIN'
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
